var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDriverWorkspace(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6324_106637",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6324_106637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2468 18.3395C9.20743 18.3395 8.22685 18.1421 7.30507 17.7474C6.38328 17.3527 5.57646 16.8095 4.88461 16.118C4.19275 15.4265 3.64937 14.62 3.25446 13.6987C2.85956 12.7773 2.66211 11.7969 2.66211 10.7576C2.66211 9.70428 2.85947 8.72023 3.25419 7.80539C3.64892 6.89055 4.19204 6.0872 4.88357 5.39535C5.57511 4.70349 6.38156 4.16011 7.30292 3.76521C8.22427 3.3703 9.20464 3.17285 10.244 3.17285C11.2973 3.17285 12.2814 3.37021 13.1962 3.76494C14.111 4.15966 14.9144 4.70278 15.6062 5.39431C16.2981 6.08585 16.8415 6.88883 17.2364 7.80325C17.6313 8.71765 17.8287 9.70149 17.8287 10.7548C17.8287 11.7942 17.6314 12.7747 17.2367 13.6965C16.8419 14.6183 16.2988 15.4251 15.6073 16.117C14.9157 16.8088 14.1128 17.3522 13.1983 17.7471C12.2839 18.142 11.3001 18.3395 10.2468 18.3395ZM9.70378 17.2305V14.2882C8.9463 14.1408 8.29539 13.7949 7.75105 13.2505C7.20671 12.7062 6.86083 12.0553 6.7134 11.2978H3.77107C3.90568 12.8918 4.52961 14.2468 5.64286 15.3627C6.75611 16.4787 8.10975 17.1013 9.70378 17.2305ZM10.7871 17.2305C12.3811 17.0852 13.7347 16.4586 14.848 15.3507C15.9612 14.2428 16.5852 12.8918 16.7198 11.2978H13.7774C13.63 12.0553 13.2841 12.7062 12.7398 13.2505C12.1954 13.7949 11.5445 14.1408 10.7871 14.2882V17.2305ZM3.77107 10.2145H6.66211L8.27309 8.57475C8.41063 8.43503 8.563 8.33312 8.73021 8.26902C8.89741 8.20491 9.06755 8.17285 9.24063 8.17285H11.2502C11.4233 8.17285 11.5934 8.20491 11.7606 8.26902C11.9278 8.33312 12.0802 8.43503 12.2178 8.57475L13.8287 10.2145H16.7198C16.5734 8.54678 15.8873 7.13679 14.6613 5.98454C13.4353 4.83229 11.9634 4.25616 10.2454 4.25616C8.52746 4.25616 7.0555 4.83229 5.82955 5.98454C4.60359 7.13679 3.91743 8.54678 3.77107 10.2145Z",
    fill: "#4E4E4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverWorkspace);
export default __webpack_public_path__ + "static/media/driver-workspace.ff5ac239bb1991dc7e8824377fdddc85.svg";
export { ForwardRef as ReactComponent };